import React from "react";
import { Check, Minus } from "lucide-react";

const PROS = [
  "Un appel de 20 minutes pour cerner ce que vous voulez faire, et ne pas faire",
  "Un itinéraire jour par jour que je travaille et valide moi-même",
  "L'appli complète, utilisable hors ligne",
  "Un assistant de voyage IA, disponible 24h/24, qui connaît votre itinéraire",
];

const CONS = [
  "Pas de suivi personnel pendant le voyage, sauf avec l'offre « Avec moi »",
  "Pas de réservation à votre place : je vous donne les bons liens, vous réservez en quelques clics",
];

export default function LandingValueProp() {
  return (
    <section className="py-20 border-t border-[#DCD4C6]" data-testid="value-prop-section">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-14">
          <h2
            className="text-4xl sm:text-5xl"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#2B2623" }}
          >
            Pourquoi si peu cher qu'un travel planner ?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 md:gap-10">
          {/* Colonne gauche */}
          <div data-testid="value-prop-column-tool">
            <h3
              className="mb-3 text-lg"
              style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#2B2623" }}
            >
              Un outil que je pilote
            </h3>
            <p className="text-sm sm:text-base text-[#5C554E] leading-relaxed" style={{ fontFamily: "'Lora', Georgia, serif" }}>
              Une travel planner classique facture ses heures de recherche : 200 à 400 € pour deux semaines.
              Moi, j'ai construit un outil qui fait la recherche. Je garde pour moi ce qui compte :
              comprendre ce que vous voulez, relire, corriger et valider. Vous payez le résultat, pas mes heures.
            </p>
          </div>

          {/* Colonne droite */}
          <div data-testid="value-prop-column-list">
            <h3
              className="mb-4 text-lg"
              style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#2B2623" }}
            >
              Ce que vous avez, et ce que vous n'avez pas
            </h3>
            <ul className="space-y-2.5 mb-4" data-testid="value-prop-pros">
              {PROS.map((item, i) => (
                <li key={i} className="flex items-start gap-2.5">
                  <Check size={16} strokeWidth={2} className="text-[#C17F59] flex-shrink-0 mt-0.5" />
                  <span className="text-sm sm:text-base text-[#5C554E]" style={{ fontFamily: "'Lora', Georgia, serif" }}>
                    {item}
                  </span>
                </li>
              ))}
            </ul>
            <ul className="space-y-2.5" data-testid="value-prop-cons">
              {CONS.map((item, i) => (
                <li key={i} className="flex items-start gap-2.5">
                  <Minus size={16} strokeWidth={2} className="text-[#9A8F86] flex-shrink-0 mt-0.5" />
                  <span className="text-sm sm:text-base text-[#9A8F86]" style={{ fontFamily: "'Lora', Georgia, serif" }}>
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p
          className="text-center mt-14 text-xl sm:text-2xl italic"
          style={{ fontFamily: "'Caveat', cursive", color: "#8B5E34" }}
          data-testid="value-prop-closing-line"
        >
          Vous voulez que je vous suive jusqu'au retour ? C'est l'offre Avec moi.
        </p>
      </div>
    </section>
  );
}
